import gql from 'graphql-tag';

export const deleteAudience = gql`
  mutation deleteAudience($audienceId: UUID!, $channelId: UUID!) {
    deleteAudience(audienceId: $audienceId, channelId: $channelId)
  }
`;
